export default __webpack_public_path__ + "fb2c4b63c51b46115404fcdf1197c4ef.png";